import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import { productPriceStore } from '@stores'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import get from 'lodash/get'
import React, { FC } from 'react'
import FieldSkeleton from '../../CellLoaders/FieldSkeleton'
import Cell from '../components/Cell'

const Currency: FC<CellItem> = ({ rowData, column }) => {
  const priceData = productPriceStore.getPriceForProduct(rowData?.id)
  if (!rowData) {
    return <FieldSkeleton />
  }
  const value = get(rowData, column.field)
  return (
    <Cell>
      <Typography variant='caption2'>
        {value
          ? formatCurrencyValueByLocale(
              priceData.kpiCurrency ? priceData.kpiCurrency : priceData.rtlCurrency,
              value
            )
          : 0}
      </Typography>
    </Cell>
  )
}

export default Currency
